<template>
	<div class="esocs">
		<div class="content">
			<v-home></v-home>
		</div>
		<back-top></back-top>
	</div>
</template>

<script>
	import ApiSetting from '../../assets/js/interface'
	import Home from '../public/Home'
	import backTop from '../public/backTop.vue'
	//	import BScroll from 'better-scroll'
	export default {
		name: 'Index',
		props: [],
		data() {
			return {
				active: false
			};
		},
		components: {
			"v-home": Home,
			backTop,
		},
		mounted() {
			//      	const wrapper = document.querySelector('.wrapper');
			//      	this.$nextTick(()=>{
			//				setTimeout(()=>{
			//					const scroll = new BScroll(wrapper,{click:true});
			//				},10)
			//			})
			//			window.scrollTo(0,0);
		},
		watch: {

		},
		computed: {

		},
		created() {},
		methods: {}
	}
</script>

<style lang="less" scoped>

</style>


// WEBPACK FOOTER //
// src/components/index/Index.vue